var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { UpdateCollaboratorApi } from '../../apis/update-collaborator-api';
import { OtherPermission } from '../../enums';
let UpdateCollaboratorsRepositoryImpl = class UpdateCollaboratorsRepositoryImpl {
    constructor(_updateCollaboratorApi) {
        this._updateCollaboratorApi = _updateCollaboratorApi;
    }
    async updateCollaborators(shareTarget, collaborators) {
        const request = {
            spaceId: shareTarget.spaceId,
            share_type: shareTarget.folderId ? 'FOLDER' : 'SPACE',
            share_ids: [shareTarget.folderId || shareTarget.spaceId],
            update_permissions: this.transformCollaboratorsToUpdatePermissions(collaborators),
        };
        const response = await this._updateCollaboratorApi.updateCollaborator(request);
        return response;
    }
    transformCollaboratorsToUpdatePermissions(collaborators) {
        return collaborators.map(this._transformCollaboratorToUpdatePermission.bind(this));
    }
    _transformCollaboratorToUpdatePermission(collaborator) {
        return {
            receiver_id: collaborator.userId,
            receiver_type: collaborator.type,
            user_role: this._transformRoleToRole(collaborator.userRole),
            sync_display_field: collaborator.syncDisplayField,
            share_expiry_at: collaborator.shareExpiryAt,
            permission_detail: this._transformPermissionDetailToUpdatePermissionDetail(collaborator.permissions),
        };
    }
    _transformRoleToRole(role) {
        switch (role) {
            case 'CUSTOM':
                return 'custom';
            case 'MANAGE':
                return 'manage';
            case 'READ':
                return 'read';
            case 'EDIT':
                return 'edit';
            default:
                throw new Error(`Invalid role: ${role}`);
        }
    }
    _transformPermissionDetailToUpdatePermissionDetail(permissionDetail) {
        return {
            patent: permissionDetail.patent,
            comment: permissionDetail.comment,
            field: permissionDetail.customField,
            folder_create: permissionDetail.others.includes(OtherPermission.FOLDER_CREATE),
            folder_edit: permissionDetail.others.includes(OtherPermission.FOLDER_EDIT),
            folder_copy: permissionDetail.others.includes(OtherPermission.FOLDER_COPY),
            folder_move: permissionDetail.others.includes(OtherPermission.FOLDER_MOVE),
            folder_delete: permissionDetail.others.includes(OtherPermission.FOLDER_DELETE),
            export: permissionDetail.others.includes(OtherPermission.EXPORT),
            assign: permissionDetail.others.includes(OtherPermission.ASSIGN),
        };
    }
};
UpdateCollaboratorsRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(UpdateCollaboratorApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof UpdateCollaboratorApi !== "undefined" && UpdateCollaboratorApi) === "function" ? _a : Object])
], UpdateCollaboratorsRepositoryImpl);
export { UpdateCollaboratorsRepositoryImpl };
